import React, { useEffect, useRef, useState } from "react";
import CinemaIcon from "../cinema/CinemaIcon";
import VodItem from "../vodItem";
import localizationStrings from "../../statics/localization";
import { getCinemaCopy } from "../../statics/cinemaCopy";

export default function RelatedVodCarousel({ items }) {
  const trackRef = useRef(null);
  const [edges, setEdges] = useState({ previous: false, next: false });
  const copy = getCinemaCopy();
  const title = localizationStrings.relatedVods;

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const measure = () => {
      const position = Math.abs(track.scrollLeft);
      const previous = position > 2;
      const next = position < track.scrollWidth - track.clientWidth - 2;
      setEdges((current) =>
        current.previous === previous && current.next === next
          ? current
          : { previous, next }
      );
    };
    measure();
    track.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    const observer =
      typeof ResizeObserver === "function" ? new ResizeObserver(measure) : null;
    if (observer) observer.observe(track);
    return () => {
      track.removeEventListener("scroll", measure);
      window.removeEventListener("resize", measure);
      if (observer) observer.disconnect();
    };
  }, [items]);

  const move = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const style = window.getComputedStyle(track);
    const card = track.firstElementChild;
    const step =
      (card ? card.getBoundingClientRect().width : track.clientWidth) +
      (parseFloat(style.columnGap) || 0);
    const distance = Math.max(1, Math.floor(track.clientWidth / step)) * step;
    track.scrollBy({
      left: direction * distance * (style.direction === "rtl" ? -1 : 1),
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth"
    });
  };

  return (
    <section className="vod-modal-related" aria-labelledby="vod-related-title">
      <div className="vod-related-heading">
        <h2 id="vod-related-title">{title}</h2>
        <div className="vod-related-controls">
          <button
            type="button"
            className="cinema-icon-button"
            aria-label={`${copy.previous}: ${title}`}
            aria-controls="vod-related-track"
            disabled={!edges.previous}
            onClick={() => move(-1)}
          >
            <CinemaIcon name="previous" />
          </button>
          <button
            type="button"
            className="cinema-icon-button"
            aria-label={`${copy.next}: ${title}`}
            aria-controls="vod-related-track"
            disabled={!edges.next}
            onClick={() => move(1)}
          >
            <CinemaIcon name="next" />
          </button>
        </div>
      </div>
      <div className="vod-related-track" id="vod-related-track" ref={trackRef}>
        {items.map((item) => (
          <VodItem
            key={item.id}
            item={item}
            isVertical={false}
            useContentType
          />
        ))}
      </div>
    </section>
  );
}
